import React, { useState, useEffect } from 'react'
import {Container} from './style'
import axios from 'axios'
import FileSaver from 'file-saver';
import {
    Button,
    Input,
    Modal,
    InputNumber,
    TreeSelect,
    Popconfirm,
    Col,
    Form,
    message,
    Icon,
    Upload,
    Select,
    Radio, Popover
} from 'antd'

import moment from 'moment'

import AICameraRequest from '../../../request/AICamera-request'

import CommonRequest from '../../../request/common-request'

import DeTable from '../../../component/DeTable';
import DeVideo from '../../../component/DeVideo'
import CommonHttp from '../../../request/common-request'
import { UploadOutlined } from '@ant-design/icons';
import {connect} from "react-redux";

const _request = new AICameraRequest()
const _common = new CommonRequest()
const _commonrequest = new CommonHttp()
const { TreeNode } = TreeSelect;

function CameraBrand(props) {
    const { sn,baseURL } = props
    const [modalType, setModalType] = useState('') //新增or编辑
    const [editVisible, setEditVisible] = useState(false) //编辑项
    const [levelEditVisible, setLevelEditVisible] = useState(false) //编辑项
    const [confirmLoading, setConfirmLoading] = useState(false) //编辑模态框加载图标
    const [deviceAddress, setDeviceAddress] = useState([])//设备位置
    const [washName, setWashName] = useState('')
    const [siteType,setSiteType] = useState('')
    const [sitePosition,setSitePosition] = useState({})
    const [siteId,setSiteId] = useState('')
    const [siteName,setSiteName] = useState('')
    const [searchSiteId,setSearchSiteId] = useState('')
    const [searchSitePositionId,setSearchSitePositionId] = useState('')
    const [searchSiteType,setSearchSiteType] = useState('')
    const [levelValue,setLevelValue] = useState('高')
    const [levelData,setLevelData] = useState({})
    const [sitePigpenName,setSitePigpenName] = useState('')
    const [sitePigpenId,setSitePigpenId] = useState('')
    const [alarmTypesList, setAlarmTypesList] = useState([])
    const [childRegionData, setChildRegionData] = useState([])
    const [searchSiteValue,setSearchSiteValue] = useState(null)
    const [searchSitePigpenId,setSearchSitePigpenId] = useState('')
    const [destoryVideo, setDestoryVideo] = useState(false)
    const [detailVideoUrl, setDetailVideoUrl] = useState('')
    const [regionName, setRegionName] = useState('')

    const tableColunm =
        [{
            title: '序号',
            key: 'number',
            render: (text, record, index) => (
                <span>{index + 1}</span>
            )
        },
            {
                title: '所属区域',
                dataIndex: 'siteName',
                key: 'siteName',
            },
            {

                title: '设备位置',
                key: 'sitePositionName',
                dataIndex: 'sitePositionName',
            },
            {
                title: '设备编号',
                key: 'sn',
                dataIndex: 'sn',
            },
            {
                title: '设备名称',
                key: 'name',
                dataIndex: 'name',
            },
            {
                title: '设备类型',
                key: 'type',
                dataIndex: 'type',
            },
            {
                title: 'IP地址',
                key: 'ipAddress',
                dataIndex: 'ipAddress',
            },
            {
                title: '在线状态',
                key: 'isOnline',
                dataIndex: 'isOnline',
                render: (text, record, index) => (
                    <div style={{ position: 'relative' }}>
                        {
                            text !== null?text?
                                <Popover content={'最后通讯时间：' + (record.offlineTime?moment(record.offlineTime).format("YYYY-MM-DD HH:mm:ss"):'-')} title="设备在线">
                                    <span style={{color: 'green'}}>在线</span>
                                </Popover>
                                :<Popover content={'设备离线时间：' + (record.offlineTime?moment(record.offlineTime).format("YYYY-MM-DD HH:mm:ss"):'-')} title="设备已离线">
                                    <span style={{color: 'red'}}>离线</span>
                                </Popover>:'-'
                        }
                    </div>
                )
            },
            {
                title: '操作时间',
                key: 'updatedDate',
                dataIndex: 'updatedDate',
                render: (text, record, index) => (
                    <span>{moment(text).format("YYYY-MM-DD HH:mm:ss")}</span>
                )
            },
            {
                title: '操作人',
                key: 'updatedName',
                dataIndex: 'updatedName',
            },
            {
                title: '操作',
                key: 'action',
                render: (text, record, index) => (
                    <span>
                        <span style={{ marginRight: 8 }} className='tableA' onClick={openModal.bind(this, 'edit', record)}>编辑</span>
                        <Popconfirm title="确认删除？" okText="删除" okType="danger" cancelText="取消" onConfirm={deleteRow.bind(this, record.id)}>
                            <span className='tableADelete'>删除</span>
                        </Popconfirm>
                    </span>
                ),
            },
        ]
    //表格结构
    const [tableTotal, setTableTotal] = useState(0)
    const [tableData, setTableData] = useState([]) //表格数据

    // 闸机记录表格结构
    const [AIVideoSiteList, setAIVideoSiteList] = useState([])
    const [addAIVideoSiteList, setAddAIVideoSiteList] = useState([])
    const [pageNo, setPageNo] = useState(1)
    const [pageSize, setPageSize] = useState(10)


    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 8 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 14 },
        },
    }
    const { getFieldDecorator } = props.form
    useEffect(() => {
        getVideoMonitorList()
        getAIVideoSiteList()
        getAddAIVideoSiteList()
        getPigfarm()
        getAlarmTypes()
        getChildRegionList()
    }, [sn])
    //获取闸机列表
    const getVideoMonitorList = (ButtonType, pageNo = 1, pageSize = 10) => {
        let params = {
            sitePigpenId: searchSitePigpenId,
            siteId: searchSiteId,
            sitePositionId: searchSitePositionId,
            pageNo,
            pageSize
        }

        if (ButtonType === 'reset') {
            params = {
                pageNo,
                pageSize
            }
        }
        _request.getFalconOneVideoList(params).then(res => {
            setTableTotal(res.total || 0)
            setTableData(res.list)
        })
    }


    //获取下属所有机构
    const getChildRegionList = () => {
        let params = {
            regionId: sessionStorage.getItem('regionId')
        }
        _commonrequest.getChildRegionListAll(params).then(res => {
            setChildRegionData(res)
        })
    }

    const getAIVideoSiteList = () => {
        _request.getAIVideoSiteList().then(res =>{
            setAIVideoSiteList(res)
        })
    }

    const getTBdAiPositions = (zoneId,pigpenId) => {
        let param = {
            zoneId,
            pigpenId
        }
        _request.getTBdAiPositions(param).then(res =>{
            setDeviceAddress(res)
        })
    }

    const getAddAIVideoSiteList = (e) => {
        const { setFieldsValue } = props.form
        setTimeout(()=>{
            setFieldsValue({
                washSpotId : null
            })
        },0)
        setAddAIVideoSiteList([])
        let region = []
        if (e){
            region = e.split('&')
            setRegionName(region[1])
        }
        let param = {
            regionId: e?region[0]:''
        }
        _request.getAddAIVideoSiteList(param).then(res =>{
            setAddAIVideoSiteList(res)
        })
    }

    //获取人员摄像头关联的猪场栋舍列表
    const getPigfarm = () => {
        let params = {
            regionType : 5,
            enterpriseType : 2
        }
        _commonrequest.getFramBuilddingList(params).then(res => {
            let list = []
            res.forEach(item => {
                let childList = []
                item.buildList.forEach(child => {
                    childList.push({
                        title: child.buildingName,
                        value: child.buildingId,
                        isLeaf: true
                    })
                })
                list.push({
                    title: item.pigFramName,
                    value: item.pigFramId,
                    children: childList,
                    // selectable: false,
                    // disableCheckbox: true
                })
            })
        })
    }

    //删除最外的表格行
    const deleteRow = (id) => {
        _request.delFalconOneVideo(id).then(res => {
            message.info('删除成功！')
            getVideoMonitorList('del')
        })
    }
    //打开编辑页
    const openModal = (type, record) => {
        const { setFieldsValue } = props.form
        setModalType(type)
        if(type === 'edit'){ // 编辑页面
            setEditVisible(true)
            getTBdAiPositions(record.siteId,record.sitePigpenId)
            setTimeout(() => {
                setSiteType(record.siteType)
                setSiteName(record.siteName)
                setSiteId(record.siteId)
                setSitePigpenName(record.sitePigpenName)
                setSitePigpenId(record.sitePigpenId)
                setSitePosition({
                    children: record.sitePositionName,
                    value: record.sitePositionId
                })
                setRegionName(record.regionName)
                setFieldsValue({
                    equipmentNo: record.sn,
                    regionId: record.regionId+'&'+record.regionName,
                    equipmentPosition: [record.sitePositionId],
                    washSpotId : record.sitePigpenId?record.sitePigpenId+'-'+record.siteId:record.siteId,
                    id: record.id,
                    name:record.name,
                    type:record.type.split(','),
                    brand:record.brand,
                    ipAddress:record.ipAddress,
                })
            }, 0)
        }else if (type === 'play'){
            setEditVisible(true)
            setDestoryVideo(false)
            // 播放
            setDetailVideoUrl(record.liveUrl)
        }else if (type === 'level'){
            setLevelEditVisible(true)
            setTimeout(() => {
                setLevelData(record)
                setLevelValue(record.riskLevel)
            },10)
        }else {
            setEditVisible(true)
        }
    }

    const { getFieldValue, validateFields, setFieldsValue } = props.form

    //编辑页提交
    const editConfire = () => {
        validateFields((err, value) => {
            if (!err) {
                setConfirmLoading(true)
                if (modalType === 'add') {
                    const formData = new FormData();
                    formData.append('sn', getFieldValue('equipmentNo')?getFieldValue('equipmentNo'):'')
                    formData.append('sitePositionName', sitePosition.children)
                    if (sitePosition.value){
                        formData.append('sitePositionId', sitePosition.value)
                    }
                    if (sitePigpenId){
                        formData.append('sitePigpenId', sitePigpenId)
                        formData.append('sitePigpenName', sitePigpenName)
                    }
                    formData.append('siteId', siteId)
                    formData.append('siteName', siteName)
                    formData.append('name', getFieldValue('name'))
                    formData.append('type', getFieldValue('type'))
                    formData.append('regionId', getFieldValue('regionId').split('&')[0])
                    formData.append('regionName', regionName)
                    formData.append('devUsername', getFieldValue('DEV_USERNAME')?getFieldValue('DEV_USERNAME'):'')
                    formData.append('devPassword', getFieldValue('DEV_PASSWORD')?getFieldValue('DEV_PASSWORD'):'')
                    formData.append('ipAddress', getFieldValue('ipAddress'))
                    formData.append('brand', getFieldValue('brand'))
                    // formData.append('regionId', sessionStorage.getItem('regionId'))
                    let params = {
                        sn: getFieldValue('equipmentNo'),
                        sitePositionName : sitePosition.children,
                        sitePositionId : sitePosition.value?sitePosition.value:null,
                        sitePigpenId,
                        sitePigpenName,
                        siteId,
                        siteName,
                        name:getFieldValue('name'),
                        type:getFieldValue('type'),
                    }
                    // axios({
                    //     method: 'POST',
                    //     url: baseURL + 'safety/falconOneVideo/add',
                    //     data: formData,
                    //     headers: {
                    //         'Content-Type': 'multipart/form-data',
                    //         'x-auth-token': sessionStorage.getItem('token'),
                    //         regionId: sessionStorage.getItem('regionId'),
                    //     },
                    // }).then(res => { // 请求成功后的处理
                    //     setConfirmLoading(false)
                    //     message.info('新增成功！')
                    //     setEditVisible(false)
                    //     getAIVideoSiteList()
                    //     getVideoMonitorList('123')
                    // }).catch(err => { // 请求失败后的处理
                    //     setConfirmLoading(false)
                    //     message.error(err);
                    // })
                    _request.addFalconOneVideo(formData).then(res => {
                        setConfirmLoading(false)
                        message.info('新增成功！')
                        setEditVisible(false)
                        getAIVideoSiteList()
                        getVideoMonitorList('123')
                    }).catch(err =>{
                        setConfirmLoading(false)
                    })
                } else {
                    const formData = new FormData();
                    formData.append('sn', getFieldValue('equipmentNo')?getFieldValue('equipmentNo'):'')
                    formData.append('sitePositionName', sitePosition.children)
                    if (sitePosition.value){
                        formData.append('sitePositionId', sitePosition.value)
                    }
                    if (sitePigpenId){
                        formData.append('sitePigpenId', sitePigpenId)
                        formData.append('sitePigpenName', sitePigpenName)
                    }
                    formData.append('siteId', siteId)
                    formData.append('siteName', siteName)
                    formData.append('name', getFieldValue('name'))
                    formData.append('type', getFieldValue('type'))
                    formData.append('regionId', getFieldValue('regionId').split('&')[0])
                    formData.append('regionName', regionName)
                    formData.append('id', getFieldValue('id'))
                    formData.append('ipAddress', getFieldValue('ipAddress'))
                    formData.append('brand', getFieldValue('brand'))
                    // formData.append('regionId', sessionStorage.getItem('regionId'))
                    let params = {
                        sn: getFieldValue('equipmentNo'),
                        sitePositionName : sitePosition.children,
                        sitePositionId : sitePosition.value?sitePosition.value:null,
                        siteType,
                        siteId,
                        sitePigpenId,
                        sitePigpenName,
                        siteName,
                        name:getFieldValue('name'),
                        id: getFieldValue('id'),
                    }
                    // axios({
                    //     method: 'PUT',
                    //     url: baseURL + 'safety/falconOneVideo/update',
                    //     data: formData,
                    //     headers: {
                    //         'Content-Type': 'multipart/form-data',
                    //         'x-auth-token': sessionStorage.getItem('token'),
                    //         regionId: sessionStorage.getItem('regionId'),
                    //     },
                    // }).then(res => { // 请求成功后的处理
                    //     setConfirmLoading(false)
                    //     message.info('修改成功！')
                    //     setEditVisible(false)
                    //     getAIVideoSiteList()
                    //     getVideoMonitorList('213')
                    // }).catch(err => { // 请求失败后的处理
                    //     setConfirmLoading(false)
                    //     message.error(err);
                    // })
                    _request.updateFalconOneVideo(formData).then(res => {
                        setConfirmLoading(false)
                        message.info('修改成功！')
                        setEditVisible(false)
                        getAIVideoSiteList()
                        getVideoMonitorList('213')
                    }).catch(err =>{
                        setConfirmLoading(false)
                    })
                }
            }
        })
    }
    //编辑页取消
    const cancelEdit = () => {
        setEditVisible(false)
        setModalType('')
        setConfirmLoading(false)
        if (modalType === 'play'){
            setDestoryVideo(true)
        }
    }
    //编辑页取消
    const cancelLevelEdit = () => {
        setLevelEditVisible(false)
        setLevelData({})
        setLevelValue('高')
    }


    //选择区域
    const selectSite = (e) => {
        setFieldsValue({
            equipmentPosition: []
        })
        const obj = comparison(e);
        setSiteId(obj.siteId)
        setSiteName(obj.siteName)
        // setSitePosition({
        //     value: obj.sitePigpenId,
        //     children: obj.sitePigpenName
        // })
        setSitePigpenName(obj.sitePigpenName)
        setSitePigpenId(obj.sitePigpenId)
        getTBdAiPositions(obj.siteId,obj.sitePigpenId)
        // setSiteType(obj.siteType)
        // if (obj.siteType === 0){
        //     setSiteId(e)
        //     setSiteName(obj.siteName)
        //     AIVideoSiteList[1].siteList.forEach(i =>{
        //         if (i.siteId === e){
        //             if (i.sitePositionList){
        //                 setDeviceAddress(i.sitePositionList)
        //             }
        //         }
        //     })
        // }else {
        //     setSiteId(obj.siteId)
        //     setSiteName(obj.siteName)
        //     setSitePosition({
        //         value: obj.sitePositionId,
        //         children: obj.sitePositionName
        //     })
        // }
    }

    //递归对比
    const comparison = (e) =>{
        let obj = {}
        let siteId = e.split('-')[1]
        let ID = e.split('-')[0]
        addAIVideoSiteList.forEach(item =>{
            // item.siteList.forEach(i =>{
            //     if (i.siteId === e){
            //         obj = i
            //     }else {
            //         if (i.sitePositionList){
            //             i.sitePositionList.forEach(j =>{
            //                 if (j.sitePositionId === e){
            //                     obj = j
            //                 }
            //             })
            //         }
            //     }
            if (item.siteId === e){
                obj = item
            }else if (item.positionList && item.positionList.length > 0){
                item.positionList.forEach(j =>{
                    if (j.sitePositionId === ID && j.siteId === siteId){
                        obj = j
                    }
                })
            }else if (item.pigpenList && item.pigpenList.length > 0){
                item.pigpenList.forEach(j =>{
                    if (j.sitePigpenId === ID && j.siteId === siteId){
                        obj = j
                    }
                })
            }
            // })
        })
        return obj
    }
    //递归对比
    const searchComparison = (e) =>{
        setSearchSiteId('')
        setSearchSiteType('')
        setSearchSitePositionId('')
        setSearchSitePigpenId('')
        let siteId = e.split('-')[1]
        let ID = e.split('-')[0]
        AIVideoSiteList.forEach(item =>{
            if (item.siteId === e){
                setSearchSiteId(item.siteId)
            }else if (item.positionList && item.positionList.length > 0){
                item.positionList.forEach(j =>{
                    if (j.sitePositionId === ID && j.siteId === siteId){
                        setSearchSiteId(j.siteId)
                        setSearchSitePositionId(j.sitePositionId)
                    }
                })
            }else if (item.pigpenList && item.pigpenList.length > 0){
                item.pigpenList.forEach(j =>{
                    if (j.sitePigpenId === ID && j.siteId === siteId){
                        setSearchSiteId(j.siteId)
                        if (j.type === 0){
                            setSearchSitePigpenId(j.sitePigpenId)
                        }else {
                            setSearchSitePositionId(j.sitePigpenId)
                        }
                    }else {
                        if (j.positionList){
                            j.positionList.forEach(i =>{
                                if (i.sitePositionId === ID && i.siteId === siteId){
                                    setSearchSiteId(i.siteId)
                                    setSearchSitePositionId(i.sitePositionId)
                                }
                            })
                        }
                    }
                })
            }
        })
    }

    //获取警报类型
    const getAlarmTypes = () =>{
        _request.getAlarmTypes().then(res => {
            const arr = res.map(i =>{
                return {name: i}
            })
            setAlarmTypesList(arr)
        })
    }

    //搜索
    const clickSearch = () => {
        setPageNo(1)
        setPageSize(10)
        getVideoMonitorList('123')
    }

    //导出
    const clickExport = () => {

        // _request.exportFalconOneVideo({
        //     sitePigpenId: searchSitePigpenId,
        //     siteId: searchSiteId,
        //     sitePositionId: searchSitePositionId,
        // }).then(res =>{
            // 获取到文件流后，将其保存为文件并下载
            // console.log(res);
            // const blob = new Blob([res]);
            // FileSaver.saveAs(blob, 'example.xlsx');
            // const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            // const url = URL.createObjectURL(blob);
            // const a = document.createElement('a');
            // a.href = url;
            // a.download = 'file.xlsx'; // 文件名，可以根据需要修改
            // a.click();
            // URL.revokeObjectURL(url);

            // let blob = new Blob([res]);
            // let downloadElement = document.createElement("a");
            // let href = window.URL.createObjectURL(blob); //创建下载的链接
            // downloadElement.href = href;
            // // downloadElement.download = decodeURIComponent(res.headers.filename); //下载后文件名
            // downloadElement.download = `采食历史记录.xlsx`; //下载后文件名
            // document.body.appendChild(downloadElement);
            // downloadElement.click(); //点击下载
            // document.body.removeChild(downloadElement); //下载完成移除元素
            // window.URL.revokeObjectURL(href); //释放blob对象
        // })
        // window.location.href = 'http://192.168.200.13:8081'+"/api/safety/falconOneVideo/export?sitePigpenId="
        //     +searchSitePigpenId+"&siteId="+searchSiteId+"&sitePositionId="+searchSitePositionId
        axios({
            url: baseURL + 'safety/falconOneVideo/export',
            method: 'GET',
            params: {
                sitePigpenId: searchSitePigpenId,
                siteId: searchSiteId,
                sitePositionId: searchSitePositionId,
            },
            headers: {
                'x-auth-token': sessionStorage.getItem('token'),
                regionId: sessionStorage.getItem('regionId'),
            },
            responseType: 'blob' // 设置响应类型为二进制流
        })
            .then(response => {
                // 将二进制流转换为 URL 对象
                const url = window.URL.createObjectURL(new Blob([response], { type: 'application/vnd.ms-excel' }));
                // 创建一个链接元素
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'example.xlsx'); // 设置文件名
                // 将链接元素添加到文档中
                document.body.appendChild(link);
                // 模拟点击链接元素进行下载
                link.click();
                // 下载完成后移除链接元素
                document.body.removeChild(link);
            })
            .catch(error => {
                console.error(error);
            });



    }

    //重置
    const clickReset = () => {
        setWashName('')
        setSearchSiteId('')
        setSearchSiteType('')
        setSearchSitePositionId('')
        setSearchSiteValue(null)
        setPageNo(1)
        setPageSize(10)
        getVideoMonitorList('reset')
    }
    const onPaginationChange = (pageNo, pageSize) =>{
        setPageSize(pageSize);
        setPageNo(pageNo);
        //查询
        getVideoMonitorList('',pageNo,pageSize);
    }


    const { Option } = Select;

    return (
        <Container>
            <div className="top">
                <Button type="primary" style={{ marginRight: 10,backgroundColor: '#689F38',borderColor: '#689F38' }} onClick={openModal.bind(this, 'add')}><span className='iconfont icon-tianjia buttonIcon'></span>新增</Button>
                <TreeSelect
                    style={{ width: 200, marginRight: 10 }}
                    dropdownStyle={{ maxHeight: 300, overflow: 'auto' }}
                    placeholder="请选择区域"
                    allowClear
                    value={searchSiteValue}
                    onChange={(value,options,extra)=>{
                        setSearchSiteValue(value)
                        searchComparison(value)
                    }}
                >
                    {
                        AIVideoSiteList.length > 0 ?
                            AIVideoSiteList.map((item,index) =>{
                                return <TreeNode value={item.siteId} title={item.siteName} key={item.siteId}>
                                    {
                                        item.positionList && item.positionList.length > 0?item.positionList.map(i =>{
                                            return <TreeNode value={i.sitePositionId+'-'+i.siteId} title={i.sitePositionName} key={i.sitePositionId}>
                                            </TreeNode>
                                        }):(item.pigpenList && item.pigpenList.length > 0?item.pigpenList.map(i =>{
                                            return <TreeNode value={i.sitePigpenId+'-'+i.siteId} title={i.sitePigpenName} key={i.sitePigpenId}>
                                                {
                                                    i.positionList && i.positionList.length > 0?i.positionList.map(j =>{
                                                        return <TreeNode value={j.sitePositionId+'-'+j.siteId} title={j.sitePositionName} key={j.sitePositionId} />
                                                    }):''
                                                }
                                            </TreeNode>
                                        }):'')
                                    }
                                </TreeNode>
                            })
                            :''
                    }
                </TreeSelect>
                <Button type="primary" style={{ marginRight: 10 }} onClick={clickSearch}><span className='iconfont icon-sousuo buttonIcon'></span>搜索</Button>
                <Button type="primary" style={{ marginRight: 10 }} className='buttonReset' onClick={clickReset}><span className='iconfont icon-zhongzhi buttonIcon' style={{fontSize: 14}}></span>重置</Button>
                <Button type="primary" style={{ marginRight: 10 }} onClick={clickExport}><UploadOutlined />导出</Button>
            </div>
            <div className="bottom">
                <DeTable columns={tableColunm} total={tableTotal}
                         setOn={setPageNo}
                         setSize={setPageSize}
                         current={pageNo}
                         pageSize={pageSize}
                         onPaginationChange={(pageNo, pageSize) => onPaginationChange(pageNo, pageSize)}
                         dataSource={tableData} />
            </div>
            <Modal
                title={modalType === 'add' ? '新增' : '编辑'}
                visible={editVisible}
                onCancel={cancelEdit}
                maskClosable={false}
                destroyOnClose={modalType === 'open' ? false : true}
                centered={true}
                width={'50%'}
                className='editClass'
                footer={
                    modalType === 'record' || modalType === 'play' ? null :
                        <div style={{ width: '100%', textAlign: 'center' }}>
                            <Button type="primary" style={{ width: 200 }} loading={confirmLoading} onClick={editConfire}>提交</Button>
                        </div>
                }
            >
                {
                    modalType === 'add' ?
                        <Form style={{ height: 400 }}>
                            <Form.Item>
                                <span></span>
                            </Form.Item>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="IP地址：">
                                    {getFieldDecorator('ipAddress', {
                                        rules: [{ required: true, message: '请输入IP地址！' }],
                                    })(
                                        <Input
                                            placeholder="请输入IP地址"
                                        />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="设备品牌：">
                                    {getFieldDecorator('brand', {
                                        rules: [{ required: true, message: '请输入品牌名称！' }],
                                    })(
                                        <Input
                                            placeholder="请输入品牌名称"
                                        />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="设备序列号：">
                                    {getFieldDecorator('equipmentNo')(
                                        <Input
                                            placeholder="请输入设备序列号"
                                        />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="设备名称：">
                                    {getFieldDecorator('name', {
                                        rules: [{ required: true, message: '设备名称！' }],
                                    })(
                                        <Input
                                            placeholder="设备名称"
                                        />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="所属机构：">
                                    {getFieldDecorator('regionId', {
                                        rules: [{ required: true, message: '请选择所属机构!' }],
                                    })(
                                        <Select placeholder="请选择所属机构" onChange={getAddAIVideoSiteList}>
                                            {
                                                childRegionData.map((item,index) => {
                                                    return (
                                                        <Option value={item.regionId+'&'+item.regionName} key={item.regionId} >{item.regionName}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    )}

                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="所属区域：">
                                    {getFieldDecorator('washSpotId', {
                                        rules: [{ required: true, message: '请选择区域！' }],
                                    })(
                                        <TreeSelect
                                            style={{ width: '100%' }}
                                            dropdownStyle={{ maxHeight: 300, overflow: 'auto' }}
                                            placeholder="请选择区域"
                                            allowClear
                                            value={searchSiteValue}
                                            onChange={selectSite}
                                        >
                                            {
                                                addAIVideoSiteList.length > 0 ?
                                                    addAIVideoSiteList.map((item,index) =>{
                                                        return <TreeNode value={item.siteId} title={item.siteName} key={item.siteId}>
                                                            {
                                                                item.positionList && item.positionList.length > 0?item.positionList.map(i =>{
                                                                    return <TreeNode value={i.sitePositionId+'-'+i.siteId} title={i.sitePositionName} key={i.sitePositionId+'-'+i.siteId}>
                                                                    </TreeNode>
                                                                }):(item.pigpenList && item.pigpenList.length > 0?item.pigpenList.map(i =>{
                                                                    return <TreeNode value={i.sitePigpenId+'-'+i.siteId} title={i.sitePigpenName} key={i.sitePigpenId+'-'+i.siteId}>
                                                                        {
                                                                            i.positionList && i.positionList.length > 0?i.positionList.map(j =>{
                                                                                return <TreeNode value={j.sitePositionId+'-'+j.siteId} title={j.sitePositionName} key={j.sitePositionId+'-'+j.siteId} />
                                                                            }):''
                                                                        }
                                                                    </TreeNode>
                                                                }):'')
                                                            }
                                                        </TreeNode>
                                                    })
                                                    :''
                                            }
                                        </TreeSelect>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="设备位置：">
                                    {getFieldDecorator('equipmentPosition', {
                                        rules: [{required: true, message: '请选择设备位置！'}],
                                    })(
                                        <Select placeholder="请输入设备位置" mode="tags"
                                                onChange={(selectValue,options) => {
                                                    if (selectValue.length > 1) {
                                                        selectValue.pop(); // 删除多余项
                                                    }
                                                    setSitePosition({})
                                                    if (selectValue.length > 0){
                                                        if (options[0].props.children === options[0].props.value){
                                                            setSitePosition({
                                                                children: options[0].props.children
                                                            })
                                                        }else {
                                                            setSitePosition({
                                                                children: options[0].props.children,
                                                                value: options[0].props.value
                                                            })
                                                        }
                                                    }
                                                }}>
                                            {
                                                deviceAddress.map((item, index) => {
                                                    return <Option key={item.id}
                                                                   value={item.id}>{item.name}</Option>
                                                })
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="设备类型：">
                                    {getFieldDecorator('type', {
                                        rules: [{required: true, message: '请选择设备类型！'}],
                                    })(
                                        <Select placeholder="请选择设备类型" maxTagCount={1} mode="multiple" showSearch>
                                            {
                                                alarmTypesList.map((item, index) => {
                                                    return <Option key={item.name} value={item.name}>{item.name}</Option>
                                                })
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            {
                                getFieldValue('type') === '工服识别'?
                                    <div>
                                        <Col span={12}>
                                            <Form.Item {...formItemLayout} label="设备账号：">
                                                {getFieldDecorator('DEV_USERNAME', {
                                                    rules: [{ required: true, message: '请输入设备账号！' }],
                                                })(
                                                    <Input
                                                        placeholder="设备账号"
                                                    />,
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item {...formItemLayout} label="设备密码：">
                                                {getFieldDecorator('DEV_PASSWORD', {
                                                    rules: [{ required: true, message: '请输入设备密码！' }],
                                                })(
                                                    <Input
                                                        placeholder="设备密码"
                                                    />,
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </div>:
                                    <div>
                                        <Col span={12}>
                                            <Form.Item {...formItemLayout} label="设备账号：">
                                                {getFieldDecorator('DEV_USERNAME')(
                                                    <Input
                                                        placeholder="设备账号"
                                                    />,
                                                )}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item {...formItemLayout} label="设备密码：">
                                                {getFieldDecorator('DEV_PASSWORD')(
                                                    <Input
                                                        placeholder="设备密码"
                                                    />,
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </div>
                            }
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="风险等级：">
                                    {getFieldDecorator('riskLevel', {
                                        rules: [{ required: true, message: '请选择风险等级!' }],
                                    })(
                                        <Select placeholder="请选择风险等级">
                                            <Option value='高'>高</Option>
                                            <Option value='中'>中</Option>
                                            <Option value='低'>低</Option>
                                        </Select>
                                    )}

                                </Form.Item>
                            </Col>
                        </Form>
                        :
                        <Form style={{ height: 400 }}>
                            <Form.Item>
                                {getFieldDecorator('id')(
                                    <span></span>
                                )}
                            </Form.Item>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="IP地址：">
                                    {getFieldDecorator('ipAddress', {
                                        rules: [{ required: true, message: '请输入IP地址！' }],
                                    })(
                                        <Input
                                            placeholder="请输入IP地址"
                                        />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="设备品牌：">
                                    {getFieldDecorator('brand', {
                                        rules: [{ required: true, message: '请输入品牌名称！' }],
                                    })(
                                        <Input
                                            placeholder="请输入品牌名称"
                                        />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="设备序列号：">
                                    {getFieldDecorator('equipmentNo')(
                                        <Input
                                            disabled
                                            placeholder="请输入设备序列号"
                                        />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="设备名称：">
                                    {getFieldDecorator('name', {
                                        rules: [{ required: true, message: '请输入设备名称！' }],
                                    })(
                                        <Input
                                            placeholder="设备名称"
                                        />,
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="所属机构：">
                                    {getFieldDecorator('regionId', {
                                        rules: [{ required: true, message: '请选择所属机构!' }],
                                    })(
                                        <Select placeholder="请选择所属机构" onChange={getAddAIVideoSiteList}>
                                            {
                                                childRegionData.map((item,index) => {
                                                    return (
                                                        <Option value={item.regionId+'&'+item.regionName} key={item.regionId} >{item.regionName}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    )}

                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="所属区域：">
                                    {getFieldDecorator('washSpotId', {
                                        rules: [{ required: true, message: '请选择区域！' }],
                                    })(
                                        <TreeSelect
                                            style={{ width: '100%' }}
                                            dropdownStyle={{ maxHeight: 300, overflow: 'auto' }}
                                            placeholder="请选择区域"
                                            allowClear
                                            onChange={selectSite}
                                        >
                                            {
                                                addAIVideoSiteList.length > 0 ?
                                                    addAIVideoSiteList.map((item,index) =>{
                                                        return <TreeNode value={item.siteId} title={item.siteName} key={item.siteId}>
                                                            {
                                                                item.positionList && item.positionList.length > 0?item.positionList.map(i =>{
                                                                    return <TreeNode value={i.sitePositionId+'-'+i.siteId} title={i.sitePositionName} key={i.sitePositionId+'-'+i.siteId}>
                                                                    </TreeNode>
                                                                }):(item.pigpenList && item.pigpenList.length > 0?item.pigpenList.map(i =>{
                                                                    return <TreeNode value={i.sitePigpenId+'-'+i.siteId} title={i.sitePigpenName} key={i.sitePigpenId+'-'+i.siteId}>
                                                                        {
                                                                            i.positionList && i.positionList.length > 0?i.positionList.map(j =>{
                                                                                return <TreeNode value={j.sitePositionId+'-'+j.siteId} title={j.sitePositionName} key={j.sitePositionId+'-'+j.siteId} />
                                                                            }):''
                                                                        }
                                                                    </TreeNode>
                                                                }):'')
                                                            }
                                                        </TreeNode>
                                                    })
                                                    :''
                                            }
                                        </TreeSelect>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="设备位置：">
                                    {getFieldDecorator('equipmentPosition', {
                                        rules: [{required: true, message: '请选择设备位置！'}],
                                    })(
                                        <Select placeholder="请输入设备位置" mode="tags"
                                                onChange={(selectValue,options) => {
                                                    if (selectValue.length > 1) {
                                                        selectValue.pop(); // 删除多余项
                                                    }
                                                    if (selectValue.length > 0){
                                                        if (options[0].props.children === options[0].props.value){
                                                            setSitePosition({
                                                                children: options[0].props.children
                                                            })
                                                        }else {
                                                            setSitePosition({
                                                                children: options[0].props.children,
                                                                value: options[0].props.value
                                                            })
                                                        }
                                                    }
                                                }}>
                                            {
                                                deviceAddress.map((item, index) => {
                                                    return <Option key={item.id}
                                                                   value={item.id}>{item.name}</Option>
                                                })
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="设备类型：">
                                    {getFieldDecorator('type', {
                                        rules: [{required: true, message: '请选择设备类型！'}],
                                    })(
                                        <Select placeholder="请选择设备类型" mode='multiple' maxTagCount={1} showSearch>
                                            {
                                                alarmTypesList.map((item, index) => {
                                                    return <Option key={item.name} value={item.name}>{item.name}</Option>
                                                })
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item {...formItemLayout} label="风险等级：">
                                    {getFieldDecorator('riskLevel', {
                                        rules: [{ required: true, message: '请选择风险等级!' }],
                                    })(
                                        <Select placeholder="请选择风险等级">
                                            <Option value='高'>高</Option>
                                            <Option value='中'>中</Option>
                                            <Option value='低'>低</Option>
                                        </Select>
                                    )}

                                </Form.Item>
                            </Col>
                        </Form>
                }
            </Modal>
        </Container>

    )
}

const mapState = (state) => ({
    baseURL: state.baseURL,
})

const mapDispatch = (dispatch) => ({
})
// export default Form.create()(CameraBrand)
export default connect(mapState, mapDispatch)(Form.create()(CameraBrand))
